<div class="dropdown-container d-flex justify-content-between" [ngClass]="customClass">
  <div class="dropdown" (click)="toggleDropdown($event)" [class.disabled]="disabled">
    <span 
      [attr.title]="getDisplayText().length > 30 ? getDisplayText() : null" 
      [ngClass]="{ 'selected-item': (isMultiSelect ? selectedItems.length > 0 : selectedItem), 'item-placeholder': (isMultiSelect ? selectedItems.length === 0 : !selectedItem) }"
    >
      {{ getDisplayText() }}
    </span>
    <img width="12" height="12" src="../../../../assets/icons/arrow-down-small.svg" />
  </div>
  <div class="options-wrapper" *ngIf="isOpen && !disabled">
    <div *ngIf="isSearchEnabled" (click)="$event.stopImmediatePropagation()" class="search-input modal-dropdown-select-input">
      <img src="../../assets/icons/search.svg" alt="Search icon"/>
      <input
        type="text"
        placeholder="{{ 'COMMON.SEARCH' | translate }}"
        [(ngModel)]="searchValue"
        (input)="onSearchInput($event)"
      />
    </div>
    <ul class="options">
      <li *ngIf="!isRequired && isMultiSelect" (click)="selectItem(null, $event)" class="clear-selection">
        -- {{'COMMON.CLEAR_ALL' | translate}} --
      </li>
      <li *ngIf="!isRequired && !isMultiSelect" (click)="selectItem(null, $event)">
        -- {{'COMMON.NONE' | translate}} --
      </li>
      <li *ngFor="let item of items" 
          (click)="selectItem(item, $event)"
          [class.selected]="isItemSelected(item)">
        <span *ngIf="isMultiSelect" class="checkbox">
          <span *ngIf="isItemSelected(item)" class="checkmark">✓</span>
        </span>
        {{ item[displayField] }}
      </li>
    </ul>
  </div>
</div>